<script setup>
const props = defineProps({
	state: Number,
	size: Number,
	// fillColor: String,
	// clearColor: String,
})
</script>

<template>
	<div :style="`width:${size}px;`" class="xdPrrd Z1Dz7b" v-if="props.state >= 1">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path d="M0 0h24v24H0z" fill="none"></path>
			<path d="M0 0h24v24H0z" fill="none"></path>
			<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z">
			</path>
		</svg>
	</div>

	<div :style="`width:${size}px;`" class="xdPrrd" v-if="props.state < 1 && props.state > 0">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="url(#c9270)">
			<defs>
				<linearGradient id="c9270">
					<stop stop-opacity="1" offset="50%" class="Z1Dz7b"></stop>
					<stop stop-opacity="1" offset="50%" class="Wi7KIe"></stop>
				</linearGradient>
			</defs>
			<path d="M0 0h24v24H0z" fill="none"></path>
			<path d="M0 0h24v24H0z" fill="none"></path>
			<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
		</svg>
	</div>

	<div :style="`width:${size}px;`" class="xdPrrd Wi7KIe" v-if="props.state <= 0">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
			<path d="M0 0h24v24H0z" fill="none"></path>
			<path d="M0 0h24v24H0z" fill="none"></path>
			<path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z">
			</path>
		</svg>
	</div>

</template>

<style lang="scss">
.xdPrrd {
	height: auto;
}

.Z1Dz7b {
	color: var(--app_button_main_color);
	fill: var(--app_button_main_color);
	stop-color: var(--app_button_main_color);
}

.Wi7KIe {
	fill: var(--data_star_bg_color);
	fill: var(--data_star_bg_color);
	stop-color: var(--data_star_bg_color);
}
</style>
